import { useState, useEffect, useRef } from "react";
import { MathJax } from "better-react-mathjax";
import DOMPurify from "dompurify";
import {
  ChevronLeft,
  ChevronRight,
  SkipForward,
  CheckCircle2,
  XCircle,
  CircleHelp,
} from "lucide-react";

import { saveMcqResult } from "../../lib/McqApi";

const MCQPlayer = ({ content, onNext }) => {
  const questions = content.questions || [];

  const [currentQ, setCurrentQ] = useState(0);
  const [selected, setSelected] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);
  const [results, setResults] = useState([]);

  const startTimeRef = useRef(
  new Date().toISOString()
);

  useEffect(() => {
    setCurrentQ(0);
    setSelected(null);
    setSubmitted(false);
    setScore(0);
    setFinished(false);
    setResults([]);
  }, [content]);

  const q = questions[currentQ];
console.log("this is MCQPage Details:",q);
  const normalizeLatex = (text = "") =>
    text.replace(/\$dfrac/g, "$\\dfrac").replace(/\bpi\b/g, "\\pi");

 const selectedIsCorrect =
  selected !== null &&
  String(
    q?.options?.[selected]?.isCorrect
  )
    .trim()
    .toUpperCase() === "Y";

  // const saveResult = (status) => {
  //   setResults((prev) => {
  //     const next = [...prev];
  //     next[currentQ] = {
  //       qno: q.qno || currentQ + 1,
  //       question: q.qtext,
  //       status,
  //     };
  //     return next;
  //   });
  // };

  const saveResult = (status) => {

  const selectedOption =
    selected !== null
      ? q?.options?.[selected]
      : null;

  const correctOption =
    q?.options?.find(
      (x) =>
        String(x.isCorrect)
          .trim()
          .toUpperCase() === "Y"
    );

  setResults((prev) => {

    const next = [...prev];

    next[currentQ] = {

      qno:
        q.qno || currentQ + 1,

      question:
        q.question,

      status,

      questionid:
        q.qid,

      MarkedAnswer:
        selectedOption?.ansno || null,

      iscorrect:
        status === "Correct",

      CorrectAnswer:
        correctOption?.ansno || null,
    };

    return next;
  });

};


  const handleSubmit = () => {
    if (selected === null || submitted) return;
    const ok = selectedIsCorrect;
    setSubmitted(true);
    if (ok) setScore((p) => p + 1);
    saveResult(ok ? "Correct" : "Wrong");
  };

  const handleSkip = () => {
    saveResult("Skipped");
    goToNext();
  };

  const goToNext = () => {
    setSelected(null);
    setSubmitted(false);
    if (currentQ < questions.length - 1) setCurrentQ((p) => p + 1);
    else setFinished(true);
  };
  const formatHtmlWithImages = (html = "") => {
    const BASE_URL = "http://localhost:5050"; //  your backend
    //const BASE_URL = "http://45.65.41.162:8084";
    return html.replace(
      /<img([^>]+)src=["']([^"']+)["']/gi,
      (match, p1, src) => {
        if (src.startsWith("http")) return match;

        return `<img ${p1} src="${BASE_URL}${src}"`;
      },
    );
  };
  const goToPrev = () => {
    if (currentQ > 0) {
      setCurrentQ((p) => p - 1);
      setSelected(null);
      setSubmitted(false);
    }
  };

  //==============Mcq Result handler==============

  const handleFinishQuiz = async () => {

  try {

    const storedUser =
      localStorage.getItem("user");

    const userData =
      storedUser
        ? JSON.parse(storedUser)
        : {};

    const totalQuestions =
      questions.length;

    const correctAnswers =
      results.filter(
        (x) => x?.iscorrect
      ).length;

    const scorePercentage =
      totalQuestions > 0
        ? Math.round(
            (correctAnswers /
              totalQuestions) *
              100
          )
        : 0;

    const payload = {

      TestId:
        content?.testId ||
        content?.TestId,

      UserId:
          userData?.uuid,

      StartDate:
        startTimeRef.current,

      EndDate:
        new Date().toISOString(),

      TestSessionId: null,

      LoginSessionId: null,

      AcademicSessionId: null,

      TotalQuestions:
        totalQuestions,

      CorrectAnswers:
        correctAnswers,

      iscorrect:
        correctAnswers ===
        totalQuestions,

      QuestionResults:
        results.map((r) => ({
          questionid:
            r.questionid,

          MarkedAnswer:
            r.MarkedAnswer,

          iscorrect:
            r.iscorrect,

          CorrectAnswer:
            r.CorrectAnswer,
        })),

      score:
        scorePercentage,
    };

    console.log(
      "SAVE PAYLOAD:",
      payload
    );

    await saveMcqResult(payload);

    setFinished(true);

  } catch (err) {

    console.error(
      "FINISH QUIZ ERROR:",
      err
    );

    setFinished(true);

  }

};





  // Helper function for kruti detection (can be used in CommonTemplateRenderer too)
  const shouldUseKruti = (text = "") => {
    if (!text) return false;

    // Apply only if backend explicitly says Kruti font
    return /face=["']Kruti Dev 010["']/i.test(text);
  };
  if (!questions.length)
    return <div className="text-white p-6">Loading Quiz...</div>;

  if (finished) {
    return (
      <div className="p-8 text-white">
        <h1 className="text-3xl font-bold mb-3">🎉 Quiz Completed</h1>
        <p className="mb-6 text-lg">
          Score: {score} / {questions.length}
        </p>

        <div className="space-y-3 max-h-[60vh] overflow-auto pr-2">
          {questions.map((item, i) => {
            const result = results[i]?.status || "Not Attempted";
            const icon =
              result === "Correct" ? (
                <CheckCircle2 className="w-5 h-5" />
              ) : result === "Wrong" ? (
                <XCircle className="w-5 h-5" />
              ) : (
                <CircleHelp className="w-5 h-5" />
              );

            return (
              <div
                key={item.qid || i}
                className="bg-slate-800 rounded-xl p-4 flex items-start justify-between gap-4"
              >
                <div>
                  <div className="font-semibold">Q{item.qno || i + 1}</div>
                  <div className="text-sm opacity-80">
                    {item?.question?.replace(/<[^>]*>/g, "")}
                  </div>
                </div>
                <div className="flex items-center gap-2 font-medium">
                  {icon}
                  <span>{result}</span>
                </div>
              </div>
            );
          })}
        </div>

        <button
          onClick={onNext}
          className="mt-6 px-5 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 flex items-center gap-2"
        >
          Continue <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="text-white p-6 max-w-5xl mx-auto">
      <div className="mb-4 font-bold text-lg">
        Question {currentQ + 1} / {questions.length}
      </div>

      <MathJax dynamic>
        <div
          className={`text-2xl mb-6 leading-10 ${
            shouldUseKruti(q?.question) ? "kruti" : ""
          }`}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(formatHtmlWithImages(q?.question)),
          }}
        />
      </MathJax>

      <div className="space-y-4 overflow-auto">
        {q?.options?.map((opt, i) => {
          const isCorrect = String(opt.isCorrect).trim().toUpperCase() === "Y";
          const bg = submitted
            ? selectedIsCorrect
              ? selected === i
                ? "bg-emerald-600 border-emerald-400"
                : "bg-slate-800 border-slate-700"
              : selected === i
                ? "bg-red-600 border-red-400"
                : isCorrect
                  ? "bg-emerald-600 border-emerald-400"
                  : "bg-slate-800 border-slate-700"
            : selected === i
              ? "bg-indigo-600/30 border-indigo-400 scale-[1.01]"
              : "bg-slate-800 border-slate-700 hover:border-indigo-400 hover:bg-slate-700";

          return (
            <button
              key={i}
              onClick={() => !submitted && setSelected(i)}
              className={`w-full text-left rounded-2xl border-2 px-5 py-4 transition-all duration-200 ${bg}`}
            >
              <div className="flex justify-between items-center gap-4">
                <div className="flex items-center gap-4 w-full">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center font-bold text-indigo-300 shrink-0">
                    {String.fromCharCode(65 + i)}
                  </div>

                  <MathJax dynamic>
                    <div
                      className={`${shouldUseKruti(opt.text) ? "kruti" : ""} text-lg`}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          formatHtmlWithImages(normalizeLatex(opt.text)),
                        ),
                      }}
                    />
                  </MathJax>
                </div>
                {submitted && (
                  <span className="font-semibold whitespace-nowrap">
                    {selectedIsCorrect
                      ? selected === i
                        ? "✓ Correct"
                        : ""
                      : selected === i
                        ? "✗ Wrong"
                        : isCorrect
                          ? "✓ Correct"
                          : ""}
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-3 mt-8">
        <button
          onClick={goToPrev}
          disabled={currentQ === 0}
          className="px-4 py-3 rounded-xl bg-slate-700 disabled:opacity-40 flex items-center gap-2"
        >
          <ChevronLeft className="w-4 h-4" /> Prev
        </button>

        {!submitted && (
          <button
            onClick={handleSubmit}
            disabled={selected === null}
            className="px-4 py-3 rounded-xl bg-indigo-600 disabled:opacity-40 flex items-center gap-2"
          >
            <CheckCircle2 className="w-4 h-4" /> Submit
          </button>
        )}

        {!submitted && (
          <button
            onClick={handleSkip}
            className="px-4 py-3 rounded-xl bg-amber-600 flex items-center gap-2"
          >
            <SkipForward className="w-4 h-4" /> Skip
          </button>
        )}

        <button
  onClick={() => {

    if (
      currentQ ===
      questions.length - 1
    ) {

      if (!submitted) {

        handleSubmit();

        setTimeout(() => {
          handleFinishQuiz();
        }, 300);

      } else {

        handleFinishQuiz();

      }

    } else {

      goToNext();

    }

  }}
          className="ml-auto px-4 py-3 rounded-xl bg-emerald-600 flex items-center gap-2"
        >
          {currentQ === questions.length - 1 ? "Finish" : "Next"}
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MCQPlayer;